import CustomButton from "../../../../component/elements/CustomButton/CustomButton";
import StoreCard from "../../components/storeCard";
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";
import SectionWrapper from "../../components/sectionWrapper";
import ButtonContainer from "../../components/buttonContainer";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import axiosInstance from "../../../../configuration/request";
import { storePayload } from "../../../../utils/storePayload";
import { useSnackbar } from "../../../../component/SnackbarContext";
import { setShopDetails } from "../../../../Redux/Slices/customerSlice";
import { cardData } from "../../../../constants/shopDetails";

const SelectShop = () => {
  const dispatch = useDispatch();
  const {
    orderFlow,
    selectedService,
    cartItems,
    pickupDetails,
    payloadAddress,
    shopDetails,
  } = useSelector((state) => state.customer);
  const navigate = useNavigate();
  const showSnackbar = useSnackbar();
  const [shops, setShops] = useState([]);
  const [selectedLaundry, setSelectedLaundry] = useState(null);
  const [selectedShop, setSelectedShop] = useState({});

  const handleCardSelect = (laundry) => {
    setSelectedLaundry(laundry.id);
    setSelectedShop(laundry);
  
  };

  useEffect(() => {
    if (cartItems.length > 0) {
      fetchShops();
    }

  }, [cartItems]);

  const fetchShops = () => {
    let payload = storePayload(
      cartItems,
      pickupDetails,
      payloadAddress,
      selectedService
    );
    axiosInstance
      .post(`/customer/services-offered/estimate`, payload)
      .then((res) => {
        const rawData = res.data;
        const mappedShops = rawData.map((shop) => {
          const { store, averageRating, totalPrice, matchedItems, originalPrice } = shop;
          const today = new Date().toLocaleDateString("en-US", {
            weekday: "long",
          });
          const todayHours = store?.store_hours?.[today] || null;
          let description = "";
          let services = [];
          if (selectedService === "Tailoring") {
            // Collect all tailoringType names
            const tailoringTypes = matchedItems
              .flatMap((item) => item.matches)
              .map((match) => match.tailoringType?.name)
              .filter(Boolean);

            const tailoringDescriptions = matchedItems
              .flatMap((item) => item.matches)
              .map((match) => match.tailoringType?.description)
              .filter(Boolean);

            description =
              tailoringDescriptions.length > 0
                ? tailoringDescriptions[0]
                : "No description available";
            services = tailoringTypes;
          } else {
            description =
              matchedItems.length > 0
                ? matchedItems[0].match.description
                : "No description available";
            services = matchedItems.map((item) => item.match.category);
          }
          const shopImageDoc = store?.uploadDoc?.find(
            (doc) => doc.name === "shop_image"
          );
          const image = shopImageDoc ? shopImageDoc.fileUrl : null;
          return {
            id: store?.id,
            matchedItems: matchedItems,
            title: store?.storeName,
            totalPrice: totalPrice,
            time: todayHours,
            status: store?.storeStatus ? "Open" : "Closed",
            description,
            services,
            rating: averageRating || 0,
            image,
            isFavorite: shop?.isFavourite,
            storeAddress: store?.storeAddresses[0],
            preferred: store?.preferred,
            originalPrice: originalPrice
          };
        });
        setShops(mappedShops);
        if (shopDetails) {
          setSelectedLaundry(shopDetails?.id || null);
          setSelectedShop(shopDetails);
        }
      })
      .catch((err) => showSnackbar("Something went wrong!", "error"));
  };

  const previousHandler = () => {
    navigate("/add-to-cart");
  };
  const nextHandler = () => {
    if (selectedShop && Object.keys(selectedShop).length > 0) {
      dispatch(setShopDetails(selectedShop));
      navigate("/review-place-order");
    } else {
      showSnackbar("Please select shop before proceeding.", "error");
    }
  };

  return (
    <SectionWrapper title="Choose" subTitle="Shop">
      <div className="w-full px-6 lg:px-8  overflow-y-auto">
        <div className="mb-3">
          <ButtonContainer
            handleNext={nextHandler}
            handlePrevious={previousHandler}
          />
        </div>
        <div className="flex flex-wrap justify-start gap-6 pt-2 pb-4 items-stretch h-[300px] md:h-[350px]">
          {shops.length > 0 ? (
            shops.map((shop) => (
              <div className="min-w-[220px] max-w-[250px] md:min-w-[280px] md:max-w-[280px] xl:min-w-[300px] xl:max-w-[310px] ">
                <StoreCard
                  key={shop.id}
                  laundry={shop}
                  isOrderNow={false}
                  selected={selectedLaundry === shop.id}
                  onCardSelect={() => handleCardSelect(shop)}
                  showEstimate={true}
                  updateFavorit={() => {
                    fetchShops();
                  }}
                />
              </div>
            ))
          ) : (
            <p className="text-gray-600">No shops found.</p>
          )}
        </div>
      </div>
    </SectionWrapper>
  );
};

export default SelectShop;
